<div class="layout-wrapper" [ngClass]="layoutController.rootPageClasses()">
  <pv2-notify-component></pv2-notify-component>
  <knhc-header></knhc-header>
  @if (this.station.isLoaded()) {
    <router-outlet></router-outlet>
  } @else {
    <div class="text-center text-xl mt-4 text-red-500 font-bold">Well that's not good, we were unable to load the station's information.</div>
    <div class="text-center text-lg mt-2">Please try again later.</div>
  }
  <knhc-footer></knhc-footer>
</div>
